import React from 'react';
import { Row, Col } from 'antd';
import ImageLoader from '../ImageLoader';
import StoryPresenter from '../StoryPresenter';

function FullView({ hasImages, realmObjectID, realmObject }) {
  return (
    <Row className="content-wrapper" wrap="true">
      {hasImages && (
        <Col xs={24} sm={8} style={{ textAlign: 'center', marginBottom: 16 }}>
          <ImageLoader key={realmObjectID} realmObject={realmObject} />
        </Col>
      )}
      <Col xs={24} sm={hasImages ? 16 : 24} style={{ paddingLeft: hasImages ? 16 : 0 }}>
        <StoryPresenter fieldKey="ShortStory" />
        <StoryPresenter fieldKey="LongStory" />
      </Col>
    </Row>
  );
}

export default FullView;
